import { FILTER_TYPES } from "../constants/FilterTypes";
import { type FilterType } from "../types/FilterType";

export class DataTableFilterModel {
    static isEmpty(type: FilterType, value: any): boolean {
        switch (type) {
            case FILTER_TYPES.LIST:
                return !value?.length;

            case FILTER_TYPES.TEXT:
                if (Array.isArray(value)) {
                    return value.length === 0;
                }

                if (typeof value === 'string') {
                    return value.trim() === '';
                }

                return value == null;

            case FILTER_TYPES.BOOLEAN:
                return value == null;

            case FILTER_TYPES.DATE_RANGE:
            case FILTER_TYPES.DATE_TIME_RANGE:
            case FILTER_TYPES.NUMBER_RANGE:
            case FILTER_TYPES.AMOUNT:
                return value?.from == null && value?.to == null;

            default:
                return value == null;
        }
    }

    static isActive(value: any): boolean {
        return (
            value != null &&
            value !== '' &&
            !(Array.isArray(value) && value.length === 0) &&
            !(
                typeof value === 'object' &&
                !Array.isArray(value) &&
                value.from == null &&
                value.to == null
            )
        );
    }
}